import { useMutation } from '@tanstack/react-query';
import { showcaseApi } from '../api/showcaseApi';
import type { ExcelRequest, ApiError } from '../types/showcase';

/**
 * Mutation: POST /api/eraf/showcase/excel
 * Returns blob → triggers browser download.
 * p95 target < 800ms for rows ≤ 1000.
 */
export function useExcelDemo() {
  return useMutation<Blob, ApiError, ExcelRequest>({
    mutationFn: (req) => showcaseApi.excel(req),
    mutationKey: ['common-showcase', 'excel'],
  });
}
